import React from 'react'
import Footer from '../../Footer'
import fig1 from '../../../img/tech/BIT/1.png'
import '../Proj.css'


export default class ProjBIT extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div className='proj-wrap-86'>
                    <div id='texel-title'>
                        <h1>Computer System Laboratory Lab Project Design</h1>
                    </div>
                    <p className='little-title'>Designed a lab project along with performing in-class implementation instructions (undergraduate-level) as teachering assistant of Computer System Laboratory, taught by Prof. Lung-Pan Cheng</p>
                    
                    <p>
                        The new lab project is designed to help students in the computer science department to get started with hardware/software integration.
                        It is the first lab that introduces Arduino and other basic components, such as buttons and potentiometers, also the essential concepts of implementing and testing circuits.
                    </p>
                    <div className='proj-fig1'>
                        <img src={fig1} />
                    </div>

                    
                    <Footer back={true}/>
                </div>
                
            </div>
        )
    }
}